import React from 'react';
import { Navigate } from 'react-router-dom';

const ListadoDespachosAccordion = () => (
    <Navigate to="/login" replace state={{ from: '/despachos' }} />
);

export default ListadoDespachosAccordion;
